// Bootstrap
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from 'react-bootstrap/Badge';
import Stack from 'react-bootstrap/Stack';
import { Eye } from 'react-bootstrap-icons';

// Api
import Api from "../api.js";

const WatchlistItem = ({item}) => {
  return (
    <Row>
      <Col>
        <a style={{textDecoration: "none", fontSize: "16px"}} 
          onClick={ () => Api.trackClick(item.id) } href={item.url} target="_blank">{item.title}</a>
        <p style={{color: "#636464", fontSize: "12px", marginBottom: "8px"}}>{item.description}</p>
        <Stack direction="horizontal" gap={2}>
          <span style={{color: "#636464", fontSize: "11px"}}><Eye/> {item.clicks}</span>
          {item.tags.map((tag) => <Badge key={tag} style={{fontSize: "10px"}}text="dark" bg="light">{tag}</Badge>)}
        </Stack>
      <hr/>
      </Col>
    </Row>
  )
};

export default WatchlistItem;
